// Canonical client routes for entities.
// Version detail lives under its app: /apps/:pid/versions/:id.
// The bare /versions/:id route is kept for backward compatibility and as a
// fallback when the caller only has a version id (no pid).
export const versionDetailPath = (v: {
  id: string | number;
  pid?: string | number | null;
}) => (v.pid ? `/apps/${v.pid}/versions/${v.id}` : `/versions/${v.id}`);

// Work items have one stable URL per PRD × App, including unscheduled work.
export const engagementDetailPath = (id: string) => `/e/${id}`;

// Document-only references (reports, parents without a visible work item)
// may not have an engagement id; /prds/:id is then a redirect route that
// resolves the document to its /e/:id work item (WED-275).
export const prdDetailPath = (id: string, engagementId?: string) =>
  engagementId ? engagementDetailPath(engagementId) : `/prds/${id}`;

// Landing work item for a document link: prefer the route's App, then any
// App the user can see (from the server's /apps list), else the first one —
// the server still admits owners, creators and viewer-list members there.
export const pickWorkItem = <E extends { id: string; appId?: string | number | null }>(
  engagements: E[] | undefined,
  visibleAppIds: Set<string>,
  preferAppId?: string | number | null
): E | undefined => {
  const visible = (engagements ?? []).filter((e) => visibleAppIds.has(String(e.appId)));
  return (
    (preferAppId != null ? visible.find((e) => String(e.appId) === String(preferAppId)) : undefined) ??
    visible[0] ??
    engagements?.[0]
  );
};
